import productImage from '../resources/images/util/user.png';

export default function () {
  return [
    {
      id: 1,
      imgUrl: productImage,
      name:'KPI Dirección',
      url: 'direction'
    },
    {
      id: 2,
      imgUrl: productImage,
      name:'KPI Cliente',
      url: 'client'
    },
    {
      id: 3,
      imgUrl: productImage,
      name:'KPI Operación',
      url: 'operation'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/reducers/productReducers.js